import React from 'react';
import Layout from '../components/layout/Layout';
import Quiz from '../components/quiz/Quiz';
import { QuizProvider } from '../context/QuizContext';

const QuizPage: React.FC = () => {
  return (
    <QuizProvider>
      <Layout>
        <Quiz />
      </Layout>
    </QuizProvider>
  );
};

export default QuizPage; 